import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  DetailedCallRecord,
  NumberSearchResult,
  UsernameSearchResult,
} from '../../../shared/models/generated/ziroModels';
import { FileDownloadService } from '../../../shared/services/file-download.service';

export enum DetailedCallRecordDirection {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
  BOTH = 'BOTH',
}

export interface CallRecordsParams {
  direction: DetailedCallRecordDirection;
  userPrincipalName?: string;
  displayName?: string;
  number?: string;
  startDate: string;
  endDate: string;
}

@Injectable()
export class DetailedCallRecordsReportResource {
  private _http = inject(HttpClient);
  private fileDownloadService = inject(FileDownloadService);
  private _baseUrl = '/services/microsoft/reporting/tenants';

  getCallRecords(tenantId: string, params: CallRecordsParams): Observable<DetailedCallRecord[]> {
    return this._http.get<DetailedCallRecord[]>(`${this._baseUrl}/${tenantId}/pstn-call-finder-records`, {
      params: { ...params },
    });
  }

  export(tenantId: string, params: CallRecordsParams): Observable<void> {
    return this.fileDownloadService.downloadFile(
      `${this._baseUrl}/${tenantId}/pstn-call-finder-records/export`,
      'get',
      params,
    );
  }

  numbersSearch(tenantId: string, query: string): Observable<NumberSearchResult[]> {
    return this._http.get<NumberSearchResult[]>(
      `${this._baseUrl}/${tenantId}/pstn-call-finder-records/numbers/search?q=${encodeURIComponent(query)}`,
    );
  }

  userPrincipalNamesSearch(tenantId: string, query: string): Observable<UsernameSearchResult[]> {
    return this._http.get<UsernameSearchResult[]>(
      `${this._baseUrl}/${tenantId}/pstn-call-finder-records/user-principal-names/search?q=${encodeURIComponent(query)}`,
    );
  }
}
